import React, { useState, useEffect, useRef } from 'react';
import { FiPlus, FiDownload, FiTrash2 } from 'react-icons/fi';
import { documentAPI } from '../../services/api';
import DataTable from '../../components/shared/DataTable';

const DocumentListPage = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const fileRef = useRef(null);

  const fetchDocuments = () => documentAPI.list().then(r => { setDocuments(r.data); setLoading(false); }).catch(() => setLoading(false));
  useEffect(() => { fetchDocuments(); }, []);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', file.name);
    await documentAPI.create(formData);
    fetchDocuments();
  };

  const handleDelete = async (id, e) => { e.stopPropagation(); if (window.confirm('Supprimer?')) { await documentAPI.delete(id); fetchDocuments(); } };

  const columns = [
    { header: 'Nom', accessor: 'name' },
    { header: 'Type', accessor: 'file_type' },
    { header: 'Taille', render: (r) => r.file_size ? `${Math.round(r.file_size / 1024)} KB` : '-' },
    { header: 'Catégorie', render: (r) => r.category || '-' },
    { header: 'Versions', accessor: 'version_count' },
    { header: 'Ajouté par', render: (r) => r.uploader_first_name ? `${r.uploader_first_name} ${r.uploader_last_name}` : '-' },
    { header: 'Date', render: (r) => new Date(r.created_at).toLocaleDateString('fr-FR') },
    { header: 'Actions', render: (r) => (
      <div style={{ display: 'flex', gap: 4 }}>
        <a href={r.file_url} target="_blank" rel="noreferrer" className="btn btn-sm btn-secondary"><FiDownload /></a>
        <button className="btn btn-sm btn-danger" onClick={(e) => handleDelete(r.id, e)}><FiTrash2 /></button>
      </div>
    )},
  ];

  return (
    <div>
      <div className="page-header">
        <h1>Documents</h1>
        <button className="btn btn-primary" onClick={() => fileRef.current?.click()}><FiPlus /> Ajouter</button>
        <input type="file" ref={fileRef} onChange={handleUpload} style={{ display: 'none' }} />
      </div>
      {loading ? <div className="loading"><div className="spinner" /></div> : (
        <div className="card"><DataTable columns={columns} data={documents} emptyMessage="Aucun document" /></div>
      )}
    </div>
  );
};

export default DocumentListPage;
